import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';

import ButtonsCheckAll from './tables/assessment/components/ButtonsCheckAll';

import useAlert from './tables/Alerts/useAlerts';
import AlertsTable from './tables/Alerts/AlertsTable';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { FaArrowLeft } from 'react-icons/fa';

const Alert = () => {
  const { title, description, data, tableInstance } = useAlert();
  // const {selectedFlatRows} = tableInstance
  // console.log('selectedFlatRows........',selectedFlatRows[0])
  const history = useHistory()

  const { onOpenAddModal } = tableInstance;
  const addButtonClick = () => {
    // toggleAllPageRowsSelected(false);
    // setIsOpenAddEditDeleteModal(true);

    onOpenAddModal();
  };

  return (
    <>
      <HtmlHead title={title} description={description} />

      <Col>
        <div className="page-title-container mb-3">
          <Row>
            <Col className="mb-2">
            <div className="d-flex align-items-center mb-2">
                <FaArrowLeft
                  className="cursor-pointer text-primary me-2"
                  size={24}
                  onClick={() => history.goBack()}
                />
                <h1 className="mb-0 pb-0 display-4">{title}</h1>
              </div>
              <div className="text-muted font-heading text-small">{description}</div>
            </Col>
            <Col xs="5" sm="auto" className="d-flex align-items-center justify-content-end">
              <Button
                variant="outline-primary"
                className="btn-icon btn-icon-start w-100 w-md-auto"
                onClick={addButtonClick}
              >
                <CsLineIcons icon="plus" /> <span>Add</span>
              </Button>

              <ButtonsCheckAll tableInstance={tableInstance} />
            </Col>
          </Row>
        </div>
        {/* Title End */}

        <div className="mb-5">
          {data && (
            <section className="scroll-section" id="stripe">
              <AlertsTable tableInstance={tableInstance} />
            </section>
          )}
        </div>
      </Col>
    </>
  );
};

export default Alert;
